document.addEventListener("DOMContentLoaded", () => {
  $(".title-row").click(function () {
    $(this).toggleClass("active");
    $(this).siblings(".content-row").slideToggle();
  });

  function ChangeBtn() {
    const $ParentElement = $(".add-cart-btn");
    const $ButNowBtn = $(".buy-now-btn");
    const $AddtoCart = $('.column-cart-btn')
    const $OriginalPrice = $('.column-original-price')
    const $DiscountPrice = $('.column-discount-price')
    var value = $ParentElement.find(".product-variant-id").attr("value");
    var state = $ParentElement.find(".product-form__submit").attr("disabled");
    var OriginalPrice = $('.product-price-row .price__sale .price-item--last').text()
    var DiscountPrice = $('.product-price-row .price__sale .price-item--regular').text()
    $ButNowBtn.attr("data-variant-id", value);
    $AddtoCart.attr("data-variant-id", value);
    $OriginalPrice.text(OriginalPrice)
    $DiscountPrice.text(DiscountPrice)
    if (state) {
      $ButNowBtn.addClass("disabled");
      $AddtoCart.addClass("disabled");
      $AddtoCart.find('.btn-title').text('Sold out')
    } else {
      $ButNowBtn.removeClass("disabled");
      $AddtoCart.removeClass("disabled");
      $AddtoCart.find('.btn-title').text('Add to Cart')
    }
  }

  ChangeBtn();

  const targetNode = document.querySelector(".add-cart-btn");

  const observer = new MutationObserver(function (mutationsList) {
    for (const mutation of mutationsList) {
      if (mutation.type === "childList" || mutation.type === "attributes") {
        ChangeBtn();
      }
    }
  });

  const config = {
    attributes: true, 
    childList: true, 
    subtree: true, 
  };


  observer.observe(targetNode, config);
});
